export default "__VITE_ASSET__BZH2Nsnk__"